import React from 'react'
import './loadingProductos.css'

function LoadingProductos() {
  return (
    <div className='loadingProductos'>
         {
             new Array(5).fill().map((item, index)=>(
                <div key={index} className='item-category-loading'></div>
              ))
         }
    </div>
  )
}

export default LoadingProductos